"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TranslationsImpl = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var coreHttp = _interopRequireWildcard(require("@azure/core-http"));

var Mappers = _interopRequireWildcard(require("../models/mappers"));

var Parameters = _interopRequireWildcard(require("../models/parameters"));

/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

/** Class containing Translations operations. */
var TranslationsImpl = /*#__PURE__*/function () {
  /**
   * Initialize a new instance of the class Translations class.
   * @param client Reference to the service client
   */
  function TranslationsImpl(client) {
    (0, _classCallCheck2["default"])(this, TranslationsImpl);
    this.client = client;
  }
  /**
   * @param portalId
   * @param options The options parameters.
   */


  (0, _createClass2["default"])(TranslationsImpl, [{
    key: "getDefaultTranslation",
    value: function getDefaultTranslation(portalId, options) {
      var operationArguments = {
        portalId: portalId,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getDefaultTranslationOperationSpec);
    }
    /**
     * @param portalId
     * @param lang
     * @param options The options parameters.
     */

  }, {
    key: "getTranslations",
    value: function getTranslations(portalId, lang, options) {
      var operationArguments = {
        portalId: portalId,
        lang: lang,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getTranslationsOperationSpec);
    }
  }]);
  return TranslationsImpl;
}(); // Operation Specifications


exports.TranslationsImpl = TranslationsImpl;
var serializer = new coreHttp.Serializer(Mappers,
/* isXml */
false);
var getDefaultTranslationOperationSpec = {
  path: "/api/Portals({portalId})/defaultTranslation",
  httpMethod: "GET",
  responses: {
    200: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId1],
  serializer: serializer
};
var getTranslationsOperationSpec = {
  path: "/api/Portals({portalId})/translation",
  httpMethod: "GET",
  responses: {
    200: {}
  },
  queryParameters: [Parameters.lang],
  urlParameters: [Parameters.$host, Parameters.portalId],
  serializer: serializer
};